import React from "react";
import FooterCategoryData from "./FooterCategoryData";
import { ButtonLink } from "@clarkinc/zest-design-system/ui";
import { cls } from "@wss/cls";

const DesktopFooterCategoryContainer = () => {
  return (
    <>
      {FooterCategoryData.map((category) => (
        <div
          className="hidden md:flex md:flex-col"
          key={category.categoryHeader}
        >
          <h2
            className="text-white text-lg font-bold antialiased m-0 leading-normal"
            style={{ textShadow: "none" }}
          >
            {category.categoryHeader}
          </h2>
          <ul className="m-0 list-none md:pt-2 p-0">
            {category.categoryList.map((list) => (
              <li key={list.name} className="leading-4">
                <ButtonLink
                  color="white"
                  variant="plain"
                  className={cls(
                    "pl-0 py-[5px] text-sm font-normal leading-none justify-start h-auto no-underline hover:underline focus:underline",
                  )}
                  {...(list.name.toLowerCase() === "safety recall" && {
                    target: "_blank",
                    rel: "noopener",
                  })}
                  href={list.link}
                  key={list.name}
                  size="small"
                  theme="wss"
                >
                  {list.name}
                </ButtonLink>
              </li>
            ))}
          </ul>
        </div>
      ))}
    </>
  );
};

export default DesktopFooterCategoryContainer;
